import React from "react";

const AuthToggle = ({ onToggle }) => {
  return (
    <div className="toggle-container">
      <div className="toggle">
        <div className="toggle-panel toggle-right">
          <h1 id="normal">Vous êtes de retour ?</h1>
          <h1 id="mobil">De retour ?</h1>
          <p>Connectez-vous avec vos identifiants pour accéder pleinement au site.</p>
          <button className="hidden" id="login" onClick={onToggle}>
            Se connecter
          </button>
        </div>
        <div className="toggle-panel toggle-left">
          <h1>Bienvenue!</h1>
          <p>Entrez vos coordonnées personnelles pour pouvoir utiliser toutes les fonctionnalités du site.</p>
          <button className="hidden" id="register" onClick={onToggle}>
            Inscription
          </button>
        </div>
      </div>
    </div>
  );
};

export default AuthToggle;
